import { MembershipPlansProps } from "modules/membership_plan/commercial_membership_plan/commercial_membership/store/actionType";

export enum actionTypes {
  //fetch rma
  FETCH_RMA_PAYMENT_REQUEST = "FETCH_RMA_PAYMENT_REQUEST",
  FETCH_RMA_PAYMENT_SUCCESS = "FETCH_RMA_PAYMENT_SUCCESS",
  FETCH_RMA_PAYMENT_FAIL = "FETCH_RMA_PAYMENT_FAIL",
  //create stripe
  FETCH_STRIPE_PAYMENT_REQUEST = "FETCH_STRIPE_PAYMENT_REQUEST",
  FETCH_STRIPE_PAYMENT_SUCCESS = "FETCH_STRIPE_PAYMENT_SUCCESS",
  FETCH_STRIPE_PAYMENT_FAIL = "FETCH_STRIPE_PAYMENT_FAIL",
  //create stripe
  FETCH_INAPP_PURCHASE_REQUEST = "FETCH_INAPP_PURCHASE_REQUEST",
  FETCH_INAPP_PURCHASE_SUCCESS = "FETCH_INAPP_PURCHASE_SUCCESS",
  FETCH_INAPP_PURCHASE_FAIL = "FETCH_INAPP_PURCHASE_FAIL",
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface RmaPaymentProps {
  BfsBenfId: string;
  BfsBenfTxnTime: string;
  BfsBfsTxnId: string;
  BfsBfsTxnTime: string;
  BfsDebitAuthCode: string;
  BfsDebitAuthNo: string;
  BfsMsgType: string;
  BfsOrderNo: string;
  BfsRemitterBankId: string;
  BfsRemitterName: string;
  BfsTxnAmount: string;
  BfsTxnCurrency: string;
  MembershipDurationId: string;
  UserId: string;
}
export interface StripePaymentProps {
  Amount: string;
  CreatedAt: string;
  MembershipDurationId: string;
  Product: string;
  Remarks: string;
  Status: string;
  TransactionId: string;
  UpdatedAt: string;
  UserId: string;
}
export interface InAppPaymentProps {
  TransactionId:string;
  Product:string;
  PurchaseDate:string;
  UserId:string;
  MembershipDurationId:string;
  Amount:string;
  Status:string;
}

//fetch rma
export interface FetchRmaPaymentRequestAction {
  type: actionTypes.FETCH_RMA_PAYMENT_REQUEST;
}

export interface FetchRmaPaymentSuccessAction {
  type: actionTypes.FETCH_RMA_PAYMENT_SUCCESS;
  payload: RmaPaymentProps[];
}

export interface FetchRmaPaymentFailAction {
  type: actionTypes.FETCH_RMA_PAYMENT_FAIL;
  payload: string;
}

//create stripe
export interface FetchStripePaymentRequestAction {
  type: actionTypes.FETCH_STRIPE_PAYMENT_REQUEST;
}

export interface FetchStripePaymentSuccessAction {
  type: actionTypes.FETCH_STRIPE_PAYMENT_SUCCESS;
  payload: StripePaymentProps[];
}

export interface FetchStripePaymentFailAction {
  type: actionTypes.FETCH_STRIPE_PAYMENT_FAIL;
  payload: string;
}
export interface FetchInAppPurchaseRequestAction {
  type: actionTypes.FETCH_INAPP_PURCHASE_REQUEST;
}

export interface FetchInAppPurchaseSuccessAction {
  type: actionTypes.FETCH_INAPP_PURCHASE_SUCCESS;
  payload: InAppPaymentProps[];
}

export interface FetchInAppPurchaseFailAction {
  type: actionTypes.FETCH_INAPP_PURCHASE_FAIL;
  payload: string;
}

export type CouponsActions =
  | FetchRmaPaymentRequestAction
  | FetchRmaPaymentSuccessAction
  | FetchRmaPaymentFailAction
  | FetchStripePaymentRequestAction
  | FetchStripePaymentSuccessAction
  | FetchStripePaymentFailAction
  | FetchInAppPurchaseRequestAction
  | FetchInAppPurchaseSuccessAction
  | FetchInAppPurchaseFailAction;
